// extracted by mini-css-extract-plugin
export default {"page-settings":"_lnnsvg","pageSettings":"_lnnsvg","page-settings-grey":"_viw2lc","pageSettingsGrey":"_viw2lc","no-padding":"_1g90sd6","noPadding":"_1g90sd6"};